import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,
    handleTokenExpiry,
    isEmptyVariable} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {DialogSaveButton} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();

class AddProcessDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,

            processName:"",
            processShortName:"",
            formErrors:{},
            submitClickedAtleastOnce:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showCreateDialog){
            if(this.props.isEdit){
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    processName:this.props.processName,
                    processShortName:isEmptyVariable(this.props.processShortName)?"":this.props.processShortName,
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }else{
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    processName:"",
                    processShortName:"",
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleCreateDialogClose = () =>{
        this.props.handleAddEditDialogClose(false);
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleCreateMaster();
        }
    }

    handleCreateMaster = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.processName)){
            isError = true;
            FormErrorsTemp['processName'] = "Please enter process name";
        }

        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

        }else{
            let url = "";
            let postParam = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            }

            if(this.props.isEdit){
                url = Constants.UpdateProcess;
                let processObj = {
                    processId:this.props.selectedId,
                    processName:this.state.processName,
                    processShortName:this.state.processShortName
                }
                postParam.process = JSON.stringify(processObj);
                postParam.rootProcessId = this.props.rootProcessId;
            }else{
                postParam.departmentId = this.props.departmentId;
                if(this.props.createNodeType === "root"){
                    url = Constants.AddRootProcess;
                    let processObj = {
                        processId:0,
                        processName:this.state.processName,
                        processShortName:this.state.processShortName
                    }
                    postParam.process = JSON.stringify(processObj);

                }else if(this.props.createNodeType === "child"){
                    url = Constants.AddChildProcess;
                    let processObj = {
                        processId:0,
                        processName:this.state.processName,
                        processShortName:this.state.processShortName
                    }

                    postParam.childProcess = JSON.stringify(processObj);
                    postParam.parentProcessId = this.props.relativeProcessId;
                    postParam.rootProcessId = this.props.rootProcessId;
                    
                }else if(this.props.createNodeType === "sibling"){
                    url = Constants.AddSiblingProcess;

                    let processObj = {
                        processId:0,
                        processName:this.state.processName,
                        processShortName:this.state.processShortName
                    }

                    postParam.siblingProcess = JSON.stringify(processObj);
                    postParam.targetProcessId = this.props.relativeProcessId;
                    postParam.parentProcessId = this.props.relativeParentProcessId;
                    postParam.rootProcessId = this.props.rootProcessId;
                }
            }

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParam)
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    let createNodeTypeTemp = this.props.createNodeType;

                    if(createNodeTypeTemp === "root"){
                        this.setState({
                            showLoader:false,
                            processName:"",
                            processShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }else if(createNodeTypeTemp === "child" ||
                    createNodeTypeTemp === "sibling"){
                        this.setState({
                            showLoader:false,
                            processName:"",
                            processShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }
                }else{
                    this.setState({
                        showLoader:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }
    }

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showCreateDialog} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.isEdit?"Edit Process":"Add Process"}</h5>
                    <button 
                        onClick={this.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div class="modal-body">
                    <div class="addnew-modal-form">
                        <div class="addnew-modal-form-group">
                            <p>Process Short Name</p>
                            <input type="text" placeholder="Enter Process Short Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="processShortName" value={this.state.processShortName} onChange={this.handleChange}/>
                        </div>
                        <div class="addnew-modal-form-group">
                            <p>Process Name*</p>
                            <input type="text" placeholder="Enter Process Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="processName" value={this.state.processName} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['processName']) &&
                                <span class="cm-error">{this.state.formErrors['processName']}</span>
                            }
                        </div>
                    </div>
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton 
                            themeSettings={this.props.themeSettings}
                            onClick={this.handleCreateMaster} type="button" class="modal-save">
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                            </DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                themeSettings={this.props.themeSettings}
            />
            </>
        );
    }
}

export default AddProcessDialog;